import firebase from "../../config/firebase";
import api from "../api/client";

require("firebase/auth");

const authApi = {
  /**
   * Cadastro público da campanha (sem Bearer).
   * POST /auth/register-campaign-carrier
   */
  async registerCampaignCarrier({
    embarcadorUid,
    name,
    cnpj,
    whatsapp,
    email,
    password,
    loginUrl,
  }) {
    return api.post("/auth/register-campaign-carrier", {
      name,
      cnpj,
      whatsapp,
      email,
      password,
      ...(embarcadorUid ? { embarcadorUid } : {}),
      ...(loginUrl ? { loginUrl } : {}),
    });
  },

  /**
   * Altera senha Auth de um usuário via Admin SDK no backend.
   * POST /auth/update-password
   */
  async updatePassword({ uid, email, password }) {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      throw new Error("Usuário não autenticado");
    }

    const idToken = await currentUser.getIdToken(true);

    return api.post(
      "/auth/update-password",
      {
        ...(uid ? { uid } : {}),
        ...(email ? { email } : {}),
        password,
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  },

  /**
   * Cria Auth do motorista (login por CPF ou e-mail).
   * Mantém a sessão do operador web (Admin SDK no backend).
   * POST /auth/driver/create-auth
   */
  async createDriverAuth({ cpf, email, password, name, loginMode }) {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      throw new Error("Usuário não autenticado");
    }

    const idToken = await currentUser.getIdToken(true);
    const mode = loginMode === "email" ? "email" : "cpf";

    return api.post(
      "/auth/driver/create-auth",
      {
        loginMode: mode,
        cpf,
        password,
        ...(email ? { email } : {}),
        ...(name ? { name } : {}),
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  },

  /**
   * Ativa/normaliza login por CPF para motorista existente.
   * POST /auth/driver/enable-cpf-login
   */
  async enableDriverCpfLogin({ uid, cpf, password }) {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      throw new Error("Usuário não autenticado");
    }

    const idToken = await currentUser.getIdToken(true);

    return api.post(
      "/auth/driver/enable-cpf-login",
      {
        uid,
        cpf,
        ...(password ? { password } : {}),
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  },
};

export default authApi;
